import {createAction, handleActions} from 'redux-actions';
import * as api from '../services/api';
import _ from 'lodash';
import { actions as label} from './label';

// regular actions
const SET = '@translationtool/labelCollections/SET';
const SELECT = '@translationtool/labelCollections/SELECT';
const HIGHLIGHT = '@translationtool/labelCollections/HIGHLIGHT';
const RESET_SELECTED = '@translationtool/labelCollections/RESET_SELECTED';
const REMOVE = '@translationtool/labelCollections/REMOVE';
const ENABLE_FILTER = '@translationtool/projects/ENABLE_FILTER'
const DISABLE_FILTER = '@translationtool/projects/DISABLE_FILTER'

const set  = createAction(SET, labelCollections => labelCollections);
const select  = createAction(SELECT, labelCollection => labelCollection);
const highlight = createAction(HIGHLIGHT, labelCollection => labelCollection)
const resetSelected  = createAction(RESET_SELECTED);
const remove  = createAction(REMOVE, labelCollection => labelCollection);
const enableFilter = createAction(ENABLE_FILTER)
const disableFilter = createAction(DISABLE_FILTER)

export const reducer = handleActions(
	{
		[SET]: (state, action) => {
			return {...state, labelCollections: action.payload};
		},
		[SELECT]: (state, action) => {
			return {...state, selected: action.payload};
		},
        [HIGHLIGHT]: (state, action) => {
			return {...state, highlighted: action.payload};
		},
		[RESET_SELECTED]: (state) => {
			return {...state, selected: null};
		},
		[REMOVE]: (state, action) => {
			return {...state, labelCollections: _.without(state.labelCollections, _.find(state.labelCollections, {identifier: action.payload.identifier}))};
		},
        [ENABLE_FILTER]: (state) => {
            return {...state, hasFilter: true};
        },
        [DISABLE_FILTER]: (state) => {
            return {...state, hasFilter: false};
        }
	},
	{
		labelCollections: [],
		selected: null,
        hasFilter: false,
        highlighted: null
	}
);

// thunks
const selectWrapper = (identifier) => (dispatch, getState) => {
	return api.handleFetch(
		() => api.fetchLabelCollection(encodeURIComponent(getState().project.selected.name), identifier),
		dispatch,
		labelCollection => dispatch(select(labelCollection)),
		'Could not fetch labelCollection "' + identifier + '"'
	);
};

const fetch = () => (dispatch, getState) => {
	return api.handleFetch(
		() => api.fetchLabelCollections(encodeURIComponent(getState().project.selected.name)),
		dispatch,
		labelCollections => dispatch(set(labelCollections)),
		'No labelCollections found'
	);
};

const create = (labelCollection) => (dispatch, getState) => {
	return api.handleUpdate(
		() => api.createLabelCollection(encodeURIComponent(getState().project.selected.name), labelCollection),
		dispatch,
		() => dispatch(fetch())
	);
};

const update = (labelCollection) => (dispatch, getState) => {
	const identifier = getState().labelCollection.selected.identifier;
	return api.handleUpdate(
		() => api.updateLabelCollection(encodeURIComponent(getState().project.selected.name), encodeURIComponent(identifier), labelCollection),
		dispatch,
		() => dispatch(fetch())
	);
};

const deleteLabelCollection = (labelCollection) => (dispatch, getState) => {
	return api.handleUpdate(
		() => api.deleteLabelCollection(encodeURIComponent(getState().project.selected.name), encodeURIComponent(labelCollection.identifier)),
		dispatch,
		() => dispatch(remove(labelCollection))
	);
};

const lockLanguage = languageIdentifier => (dispatch, getState) => {
	const labelCollectionIdentifier = encodeURIComponent(getState().labelCollection.selected.identifier);
	return api.handleUpdate(
		() => api.lockLanguage(
			encodeURIComponent(getState().project.selected.name),
			labelCollectionIdentifier,
			encodeURIComponent(languageIdentifier)
		),
		dispatch,
		() => {
            dispatch(fetch())
		    dispatch(selectWrapper(labelCollectionIdentifier))
		}
	);
};

const finishLanguage = language => (dispatch, getState) => {
	const projectName = encodeURIComponent(getState().project.selected.name);
	const labelCollectionIdentifier = encodeURIComponent(getState().labelCollection.selected.identifier);
	const languageIdentifier = encodeURIComponent(language);

	return api.handleUpdate(
		() => api.finishLanguage(projectName, labelCollectionIdentifier, languageIdentifier),
		dispatch,
		() => {
		    dispatch(fetch())
			dispatch(selectWrapper(labelCollectionIdentifier));
			dispatch(label.fetchAllTranslationsForLanguage(languageIdentifier))
		}
	);
};

// public actions
export const actions = {
	fetch,
	create,
	update,
	delete: deleteLabelCollection,
	select: selectWrapper,
    highlightLabelCollection: highlight,
	resetSelected,
	lockLanguage,
	finishLanguage,
    enableFilter,
    disableFilter
};



// WEBPACK FOOTER //
// ./React/src/reducers/labelCollection.js